import React from 'react';
import ReactDOM from 'react-dom/client';
import Highcharts from 'highcharts';

// Global Highcharts Configuration for all charts in the project
Highcharts.setOptions({
    chart: {
        backgroundColor: '#FFFFFF',
        style: {
            fontFamily: 'inherit'
        }
    },
    exporting: {
        chartOptions: {
            chart: {
                backgroundColor: '#FFFFFF'
            }
        }
    },
    navigation: {
        buttonOptions: {
            theme: {
                fill: '#FFFFFF'
            }
        }
    }
});
import "@fontsource/montserrat"; // Defaults to 400 weight
// App.js or index.js
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/600.css";

import './index.css';
import App from './App';
import './styles/buttons.css';
import { UserProvider } from './contexts/UserContext';
import { ClientProvider } from './contexts/ClientContext';
import { AssignedToProvider } from './contexts/AssignedToContext'; 


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <ClientProvider>
        <AssignedToProvider>
          <App />
        </AssignedToProvider>
      </ClientProvider>
    </UserProvider>
  </React.StrictMode>
);
